import { overrideComponents } from './overrideComponents/components';
import { createTheme } from "@mui/material/styles";

// A custom theme for this app
export let darkTheme = createTheme({
  spacing: 6, // 8 is default
  palette: {
    mode: "dark",
    primary: {
      main: "rgba(255, 255, 255, 0.7)",
      light: "#1e78df",
      dark: "#0b4a6a",
    },
    info: {
      main: "rgb(242, 245, 249)"
    },
    // secondary: {
    //   main: '#19857b',
    // },
    // error: {
    //   main: red.A400,
    // },
    text: {
      primary: "rgba(255, 255, 255, 0.7)",
    },
    dashboardTabs: {
      blue: '#90CAF9',   // Softer Blue
      red: '#F48FB1',    // Softer Red/Pink
      yellow: '#FFF59D', // Pale Yellow
      green: '#A5D6A7',  // Mint Green
      purple: '#CE93D8', // Light Lavender
    },
    background: {
      default: "rgb(17, 25, 42)",
      paper: "rgb(17, 25, 42)",
      // paper: "rgb(41, 48, 63)",
      //neutral: "#fdfdfd",
      //hover: 'rgba(13, 98, 141, 0.04)'
    },
    border: {
      main: "rgba(0, 0, 0, 0.12)",
      light: "whitesmoke",
      dark: "black",
    },
     shadow: {
      primaryGlow: `0 3px 8px rgba(8, 81, 156, 0.2), 0 0 8px rgba(8, 81, 156, 0.2), 0 0 16px rgba(8, 81, 156, 0.15)`,
      elevatedCard: `0px 4px 20px rgba(0, 0, 0, 0.3)`,
    },
  },
  zIndex: {},
});

declare module "@mui/material/styles" {
  interface Palette {
    border: {
      main: string;
      light: string;
      dark: string;
    };
    shadow: {
      primaryGlow: string;
      elevatedCard: string;
    };
    dashboardTabs: {
      blue: string;
      red: string;
      yellow: string;
      green: string;
      purple: string;
    };
  }
  interface PaletteOptions {
    border: {
      main: string;
      light: string;
      dark: string;
    };
    shadow: {
      primaryGlow: string;
      elevatedCard: string;
    };
    dashboardTabs: {
      blue: string;
      red: string;
      yellow: string;
      green: string;
      purple: string;
    };
  }
  // interface TypeBackground {
  //   neutral: string;
  // }
}

darkTheme.components = overrideComponents(darkTheme);